module.exports = __webpack_public_path__ + "img/1.4a6d6067.jpg";